import { render, staticRenderFns } from "./iconFrontCard.vue?vue&type=template&id=8779f3c6&scoped=true"
import script from "./iconFrontCard.vue?vue&type=script&lang=js"
export * from "./iconFrontCard.vue?vue&type=script&lang=js"
import style0 from "./iconFrontCard.vue?vue&type=style&index=0&id=8779f3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8779f3c6",
  null
  
)

export default component.exports